import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';
import { useNavigate } from 'react-router-dom';
import SEO from '../seo/SEO';

const PageBg = styled.section`
  padding: 150px 0 80px;
  background:
    linear-gradient(rgba(235, 241, 248, 0.5), rgba(255, 255, 255, 0.9)),
    url('/images/HOMEFULLPAGE.webp') center/cover no-repeat;
`;

const Card = styled.div`
  max-width: 980px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.12);
  overflow: hidden;
`;

const CardHeader = styled.div`
  background: #f3ebe5;
  text-align: center;
  padding: 34px 24px 24px;
  border-bottom: 1px solid #e7dfd9;
`;

const MonoCircle = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 12px;
  border-radius: 50%;
  background: #fff;
  display: grid;
  place-items: center;
  box-shadow: 0 6px 14px rgba(0,0,0,0.08);

  img { width: 38px; height: 38px; object-fit: contain; }
`;

const Title = styled.h1`
  font-family: 'Tiro Bangla', serif;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #6b5651;
  font-size: clamp(26px, 4.2vw, 36px);
  margin: 6px 0 8px;
`;

const Subtitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-style: italic;
  color: #9b8d86;
  font-size: 14px;
  margin: 0 0 16px;
`;

const LangButton = styled.a`
  display: inline-block;
  padding: 10px 16px;
  background: #d9c9c1;
  color: #fff;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  letter-spacing: 1.8px;
  text-transform: uppercase;
  border-radius: 3px;
`;

const FrameWrap = styled.div`
  padding: 28px 34px 34px;

  @media (max-width: 600px) {
    padding: 18px;
  }
`;

const ContactPage = () => {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const formSrc = lang === 'fr'
    ? 'https://www.fotostudio.io/lead_forms/12574'
    : 'https://www.fotostudio.io/lead_forms/12560';

  const handleLangBtnClick = (e) => {
    e.preventDefault();
    // Navigate to mirrored route so /fr prefix controls language site-wide
    const target = lang === 'fr' ? '/contact#form' : '/fr/contact#form';
    navigate(target);
  };
  return (
    <PageBg>
      <SEO
        title={lang === 'fr' ? 'Contact — Lino Ludovic' : 'Contact — Lino Ludovic'}
        description={
          lang === 'fr'
            ? "Dites‑moi tout sur votre célébration : lieu, date, vision. Je vous réponds avec attention et clarté."
            : 'Tell me about your celebration: location, date, vision. I will reply with care and clarity.'
        }
        image="/images/HOMEFULLPAGE.jpg"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: lang === 'fr' ? 'Contact' : 'Contact'
        }}
      />
      <Card>
        <CardHeader>
          <MonoCircle>
            <img src="/images/Monogramme LL2 Bordeaux.webp" alt="LL monogram" />
          </MonoCircle>
          <Title>{lang === 'fr' ? 'Contact' : 'Contact'}</Title>
          <Subtitle>{lang === 'fr' ? 'Il me tarde déjà d’en savoir plus sur votre union' : 'I am looking forward to hearing more about your wedding!'}</Subtitle>
          <LangButton href="#form" onClick={handleLangBtnClick}>{lang === 'fr' ? 'Form in English' : 'Formulaire en français'}</LangButton>
        </CardHeader>
        <FrameWrap id="form">
          <iframe
            title="Fotostudio contact form"
            src={formSrc}
            width="100%"
            height="1100"
            frameBorder="0"
            allowFullScreen
            loading="lazy"
            style={{ border: 0 }}
          />
        </FrameWrap>
      </Card>
    </PageBg>
  );
};

export default ContactPage;
